/* eslint-disable @typescript-eslint/no-explicit-any */
import axios, { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import { HttpResponse } from "./common/entity/HttpResponse";
import { Message } from "element-ui";
import { host } from "@/config/host";
import Vue from "vue";
import { AjaxResponse } from "@/service/supplier-meta/entity/AjaxResponse";
import router from "@/router";
export type RequestConfig = {
  silence?: boolean;
} & AxiosRequestConfig;
function isEwoldReq(url: string) {
  return url && /^http[s]?:\/\/(.+)?.ewold.cn/.test(url);
}
function getEwoldAuthToken() {
  const microApp = (window as any).microApp;
  if (microApp) {
    const data = microApp.getData();
    return data.ewoldAuthToken;
  } else {
    return (
      router.currentRoute.query["ewoldAuthToken"] ||
      Vue.$cookies.get("AuthToken")
    );
  }
}
function createAxiosInstance(config: RequestConfig) {
  const instance = axios.create(config);
  instance.interceptors.request.use((config: AxiosRequestConfig) => {
    if (isEwoldReq(config.url || "")) {
      const authToken = getEwoldAuthToken();
      if (authToken) {
        config.headers.AuthToken = authToken;
      }
    }
    return config;
  });
  instance.interceptors.response.use(
    (
      res: AxiosResponse<HttpResponse<any>> | AxiosResponse<AjaxResponse<any>>
    ): AxiosResponse<any> | Promise<AxiosResponse<any>> => {
      const silence = !!config.silence;
      const success =
        (res?.data as HttpResponse<any>)?.is_success ||
        (res?.data as AjaxResponse<any>)?.isSuccess;
      if (!(silence || success)) {
        const errMsg =
          (res?.data as HttpResponse<any>)?.error_info?.msg ||
          (res?.data as AjaxResponse<any>)?.errorInfo?.msg;
        if (errMsg) {
          Message.error(errMsg);
        }
      }
      return res;
    },
    (err: AxiosError): any => {
      if (isEwoldReq(err.request?.responseURL)) {
        if (err?.response?.status === 401 && window.parent === window) {
          // 登录
          router.push({ name: "login" });
        }
      } else {
        throw err;
      }
    }
  );
  return instance;
}
export const request = function <T>(
  config: RequestConfig
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<T> {
  config.baseURL = host;
  config.withCredentials = true;
  //config.timeout = 30000;
  // config.withCredentials = !!host;
  const instance = createAxiosInstance(config);
  return instance.request(config).then((res) => res?.data || {});
};
